import React from "react";
import qs from "query-string";
import { withI18n } from "react-i18next";
import styled, { css } from "styled-components";
import CWBLabsFooter from "common/CWBLabsFooter";
import HorizontalDivider from "common/HorizontalDivider";
import * as SharedStyle from "common/SharedStyledComponents";
import Typography from "common/Typography";

const ConfirmationPage = ({ t, email }) => {
  const isCWBLabs = qs.parse(location.search).cwblabs;

  return isCWBLabs ? (
    <Base isCWBLabs>
      <Card>
        <Typography align="center" component="h1" variant="h3">
          {t("Reset Password Request Sent")}
        </Typography>
        <HorizontalDivider />
        <Typography align="center">
          {t("The reset password request was sent to")}:
        </Typography>
        <StyledTypography align="center" variant="bodyBold">
          {email || ""}
        </StyledTypography>
        <Typography align="center">
          {t("Please check your email for further instructions.")}
        </Typography>
      </Card>
      <CWBLabsFooter />
    </Base>
  ) : (
    <Base>
      <Wrapper>
        <SharedStyle.FormWrapper>
          <SharedStyle.FormHeader>
            {t("Reset Password Request Sent")}
          </SharedStyle.FormHeader>
          <SharedStyle.FormBody>
            <SharedStyle.StyledP>
              {t("The reset password request was sent to")}:
              &nbsp;
              {email || ""}
              .&nbsp;
              {t("Please check your email for further instructions.")}
            </SharedStyle.StyledP>
          </SharedStyle.FormBody>
        </SharedStyle.FormWrapper>
      </Wrapper>
    </Base>
  );
};

export default withI18n()(ConfirmationPage);

const Base = styled.div`
  width: 100%;
  height: calc(100vh - 60px);
  padding: 10vh 0;

  @media (max-width: 375px) {
    padding: 5vh 0;
  }

  ${(p) => p.isCWBLabs && css`
    height: calc(100vh - 80px);
    background-color: #040F1C;
  `}
`;

const Wrapper = styled.div`
  width: 610px;
  margin: auto;
  background: white;

  .cwb-dropdown-wrapper {
    margin-top: 8px;
    max-width: 100%;
    height: 40px;

    .cwb-dropdown__single-value {
      font-size: ${(p) => p.theme["xs-font-size"]};
      font-weight: ${(p) => p.theme["font-weight-600"]};
    }

    .cwb-dropdown__indicator {
      width: 14px;
    }
  }

  .cwb-dropdown-wrapper > div {
    min-width: 100%;
    max-width: 100%;
  }

  .cwb-dropdown__placeholder {
    color: ${(p) => p.theme.darkGrey};
    font-size: ${(p) => p.theme["xs-font-size"]};
  }

  .cwb-dropdown-wrapper > div .cwb-dropdown__control {
    min-height: 40px;
    border: ${(props) => props.theme.dropDown["border"]} !important;
    border-radius: ${(props) => props.theme.dropDown["border-radius"]};
  }

  @media (max-width: 475px) {
    width: 100%;
  }
`;

const Card = styled.div`
  width: 400px;
  display: flex;
  flex-flow: column nowrap;
  margin: auto;
  padding: 24px 18px 32px;
  background-color: #FFFFFF;
  border-top: 6px solid #02B8F9;
  border-radius: 4px;

  @media (max-width: 375px) {
    width: unset;
    margin: 0 16px;
  }
`;

const StyledTypography = styled(Typography)`
  margin: 8px 0;
`;
